import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { User } from '../models/user';
import { environment } from 'src/environments/environment';
import * as _ from "lodash";
import { Router } from '@angular/router';
import { RestClientService } from './rest-client.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  public currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;
  latitude: number | null = null;
  longitude: number | null = null;

  constructor(private http: HttpClient, private router: Router, private restClient: RestClientService) {

    if (localStorage.getItem('currentUser')) {
      try {
        this.currentUserSubject = new BehaviorSubject<User>(
          JSON.parse(localStorage.getItem('currentUser')));
        this.currentUser = this.currentUserSubject.asObservable();
      } catch (error) {
        console.info(" error ", error);
      }
    }

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.latitude = position.coords.latitude;
          this.longitude = position.coords.longitude;
          console.log('Captured Lat:', this.latitude, 'Lng:', this.longitude);
          let pos = { latitude: this.latitude, longitude: this.longitude }
          this.setUserPosition(pos)
        },
        (error) => {
          console.error('Error capturing location:', error);
        }
      );
    } else {
      console.error('Geolocation not supported by this browser.');
    }

  }

  public get currentUserValue(): User {
    if (this.currentUserSubject) {
      return this.currentUserSubject.value;
    } else {
      return null;
    }

  }

  public isUserAuthed() {
    // return this.currentUserValue &&  !_.isNull(this.currentUserValue.id);
    return localStorage.getItem('currentUser') !== null;
  }

  public getCurrentUser() {
    return JSON.parse(localStorage.getItem('currentUser'))
  }

  public getCurrentFileServerUrl() {
    let file_server_url = JSON.parse(localStorage.getItem('currentUser')).configuration[0].url
    console.log('file_server_url: ', file_server_url)
    return file_server_url
  }

  public setCurrentUser(item?: any) {
    // Le currentUserSubject est souvent null
    if (!this.currentUserSubject) {
      this.currentUserSubject = new BehaviorSubject<User>(new User);
      this.currentUserSubject.next(item || JSON.parse(localStorage.getItem('currentUser')));
    } else {
      this.currentUserSubject.next(item || JSON.parse(localStorage.getItem('currentUser')));
    }
  }
  public setUserPosition(position) {
    if (position) {
      localStorage.setItem('currentUserPosition', JSON.stringify(position))
    }
  }
  public getUserPosition() {
    return JSON.parse(localStorage.getItem('currentUserPosition'))
  }
  public setUserNavigationData(data) {
    if (data) {
      localStorage.setItem('currentUserNavigation', JSON.stringify(data))
    }
  }
  public getUserNavigationData() {
    return JSON.parse(localStorage.getItem('currentUserNavigation'))
  }

  getActiveUniteFonctionnelle() {
    let user = this.currentUserValue
    let cuurentId = user.uniteFoncActiveId
    if (user.uniteFonctionnelles && user.uniteFonctionnelles.length) {
      let uf = user.uniteFonctionnelles.filter((uf: any) => uf.idUniteFonctionnelle == cuurentId)[0]
      uf.id = uf.idUniteFonctionnelle
      uf.libelle = uf.libelleUniteFonctionnelle
      return uf
    }
    return {}
  }

  login(username: string, password: string, isFirstAttempt, activeUniteFonctionnelleId?) {
    let request = {
      data: {
        login: username,
        password: password,
        isFirstAttempt: isFirstAttempt,
        uniteFoncActiveId: activeUniteFonctionnelleId,
      }
    }
    return this.http
      .post<any>(`${environment.apiUrl}/user/login`, request)
      .pipe(
        map((user: any) => {
          // store user details and jwt token in local storage to keep user logged in between page refreshes
          if (user && user.items && user.items.length) {

            console.info(" user.items ", user.items);

            // Faire remonter serviceId
            if (user?.items && user?.items?.length > 0) {
              let currentUniteFonctionnelle = _.find(user.item?.uniteFonctionnelles, (o) => { return o.idUniteFonctionnelle == user.item?.uniteFoncActiveId });
              user.item.currentFonctionnaliteSelected = currentUniteFonctionnelle;
            }

            localStorage.setItem('currentUser', JSON.stringify(user.item));
            this.currentUserSubject.next(user.item);
          }
          return user;
        })
      );
  }
  logout() {
    // debugger
    if (this.getCurrentUser() && this.getCurrentUser().login && this.getCurrentUser().filiale_id) {
      console.log('login out')
      let request = {
        data: {
          login: this.getCurrentUser().login,
          filiale_id: this.getCurrentUser().filiale_id,
          ...(this.latitude !== null && this.longitude !== null && {
            latitude: this.latitude,
            longitude: this.longitude
          })

        }
      }
      this.restClient
        .post('user/logout', request
        )
        .subscribe(
          (res) => {
            localStorage.removeItem('currentUser');
            this.router.navigate(["/authentication/signin"]);

          },
          (err) => {
            localStorage.removeItem('currentUser');
            this.router.navigate(["/authentication/signin"]);


          }
        );
    }
    else {
      // localStorage.removeItem('currentUser');
      console.log("already loged out")
      this.router.navigate(["/authentication/signin"]);
    }

  }

  public checkIfUserHasAccess(code) {
    return _.find(this.getCurrentUser().fonctionnalites, (o) => { return o.code == code });
  }

  public checkIfUserHasFuncts() {
    let connectedUser = JSON.parse(localStorage.getItem('currentUser'))
    return !!connectedUser && connectedUser.fonctionnalites && connectedUser.fonctionnalites.length
  }
}
